import countries from "i18n-iso-countries";

/** Flag emoji for a two-letter country code (renders as letters where emoji flags are unsupported). */
export const flag = (code?: string | null) =>
  code && /^[A-Za-z]{2}$/.test(code) ? String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)) : "🌐";

let names: Intl.DisplayNames | null = null;
/** "UG" → "Uganda", in the viewer's language. */
export const countryName = (code?: string | null) => {
  if (!code) return "Not set";
  try {
    names ??= new Intl.DisplayNames(undefined, { type: "region" });
    return names.of(code.toUpperCase()) ?? code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
};

/** "UG" → "800", the id used by the world map. */
export const numericCode = (code: string) => countries.alpha2ToNumeric(code.toUpperCase()) ?? null;

/** Every country, sorted by name, for pickers. */
export const countryOptions = () =>
  Object.keys(countries.getNumericCodes()).length
    ? Object.values(countries.getNumericCodes())
        .map((a2) => ({ code: a2, name: countryName(a2) }))
        .filter((c) => c.name !== c.code)
        .sort((a, b) => a.name.localeCompare(b.name))
    : [];
